import React from 'react';
import { renderComponent } from 'utils/commonUtils';
import GetHelpComponent from './components/GetHelpComponent';

const GetHelp = () => {
  return renderComponent(<GetHelpComponent />);
};

export default GetHelp;
